import CrudCustom from '../../../libs/custom/CrudCustom';

let EntitasService = new CrudCustom('/entitas');
export default EntitasService;
